// extracted by mini-css-extract-plugin
export default {"services":"Services_services__7UUzX","servicesContent":"Services_servicesContent__PLM4a","service":"Services_service__FCB8j"};